import { FC, useMemo, useState, useContext } from 'react';
// 组件
import HelpTooltip from '../../HelpTooltip';
import { ProForm, ProCol } from '../../antd';
// 方法
import classnames from 'classnames';
import searchFormContext from '../context/searchFormContext';
// 常量
import { BaseSearchFormItemProps } from '../interface/baseInterface';
import { ColProps } from 'antd/lib/grid/col';
import { HelpTooltipProps } from '../../HelpTooltip/helpTooltip';

interface SearchFormItemProps extends BaseSearchFormItemProps {
  disabled?: boolean;
}
const SearchFormItem: FC<SearchFormItemProps> = props => {
  const {
    span,
    offset,
    order,
    pull,
    push,
    children,
    style,
    helpTooltipProps,
    label,
    company,
    companyWidth = 28,
    disabled,
    labelCol,
    wrapperCol,
    hideLabel,
    name,
    topTitle,
    topTitleClassName,
    // 避免变成无用dom 属性
    form: propsForm,
    testId,
    disabledRenderKey,
    uploadProps,
    ...resProps
  } = props;
  
  const [visible, setVisible] = useState<boolean>(false);
  const { form } = useContext(searchFormContext);
  const handleMouseEnter = () => {
    if (hideLabel && name && label) {
      const value = form?.getFieldValue(name);
      if (Array.isArray(value) && !value.length) return;
      if (value) setVisible(true);
    }
  };
  const renderLabel = () => {
    if (hideLabel) return undefined;
    if (helpTooltipProps) {
      const newHelpTooltipProps: HelpTooltipProps =
        typeof helpTooltipProps === 'string'
          ? { title: helpTooltipProps }
          : helpTooltipProps;
      return (
        <>
          <span>{label}</span>
          <HelpTooltip {...newHelpTooltipProps} />
        </>
      );
    }
    return label;
  };
  const currentWrapperCol: ColProps | undefined = useMemo(() => {
    if (wrapperCol) return wrapperCol;
    const labelSpan = Number(labelCol?.span);
    if (labelSpan >= 4) {
      return {
        span: 24 - Number(labelSpan),
      };
    }
  }, [wrapperCol, labelCol]);
  const classes = useMemo(() => {
    return classnames('yb-form-item', {
      'yb-form-item-hover': visible,
    });
  }, [visible]);
  return (
    <ProCol
      style={{ ...style, position: 'relative' }}
      span={span}
      offset={offset}
      order={order}
      pull={pull}
      push={push}
      data-label={label}
      className={classes}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setVisible(false)}
    >
      {!!topTitle && <div className={topTitleClassName}>{topTitle}</div>}
      <ProForm.Item
        {...resProps}
        name={name}
        wrapperCol={currentWrapperCol}
        labelCol={labelCol}
        label={renderLabel()}
      >
        {children}
      </ProForm.Item>
      {!disabled && !!company && (
        <div
          style={{
            position: 'absolute',
            right: -companyWidth + 10,
            top: 5,
            width: companyWidth,
            textAlign: 'center',
          }}
        >
          {company}
        </div>
      )}
    </ProCol>
  );
};

export default SearchFormItem;
